import SimpleLayout, { SimpleLayoutProps } from './SimpleLayout';

export type { SimpleLayoutProps };
export default SimpleLayout;
